appSocial.service('SocialInitService', [
    'SocialAPIService', 'Trader', 'SocialUserService', 'SocialPortfolioService', 'SocialConfigurationService',
    'SocialFavoriteService', 'SocialLocaleService', 'API', 'SocialThemeService', 'UserService', '$rootScope',
    function (SocialAPIService, Trader, SocialUserService, SocialPortfolioService, SocialConfigurationService,
              SocialFavoriteService, SocialLocaleService, API, SocialThemeService, UserService, $rootScope) {

        const DEFAULT_TOKEN_EXPIRATION = 24 * 3600;

        class SocialInitService {
            constructor() {
                /**
                 * @type {SocialLocaleService}
                 */
                this.localeService = SocialLocaleService;
                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;
                /**
                 * @type {API}
                 */
                this.newforexAPI = API;
                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {UserService}
                 */
                this.newforexUserService = UserService;

                /**
                 * @type {SocialPortfolioService}
                 */
                this.portfolioService = SocialPortfolioService;

                /**
                 * @type {SocialFavoriteService}
                 */
                this.favoriteService = SocialFavoriteService;

                /**
                 * @type {SocialConfigurationService}
                 */
                this.configurationService = SocialConfigurationService;

                /**
                 * @type {SocialThemeService}
                 */
                this.themeService = SocialThemeService;

                this.$rootScope = $rootScope;

                this.listener = null;

                this.initialized = false;

                // track prev/current state change
                $rootScope.previousState = null;
                $rootScope.currentState = null;
                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, options) {
                    $rootScope.previousState = {state: fromState, params: fromParams};
                    $rootScope.currentState = {state: toState, params: toParams};
                });
            }

            init() {
                return Promise.resolve()
                    .then(() => {
                        if (this.initialized) {
                            console.warn('Social is already initialized');
                            return this.checkTradingAccount();
                        }

                        return this.localeService.init()
                            .then(() => this.getToken())
                            .then(() => {
                                this.themeService.setThemeStyles();
                                // run change trading account listener
                                this.listener = this.initTradingAccountListener()
                            })
                    })
            }

            getToken() {
                return this.newforexAPI.socialClientToken()
                    .then((response) => this.login(response.token, response.trader_id, DEFAULT_TOKEN_EXPIRATION))
                    .then(() => {
                        this.initialized = true;

                        // save current trading account
                        const user = this.newforexUserService.get();
                        this.userService.activeTradingAccount = user.activeTradingAccount;
                    })
            }

            /**
             * @param {string} token
             * @param {string} traderId
             * @param {number} expireAfter
             * @return {Promise<any>}
             */
            login(token, traderId, expireAfter) {
                return this.api.request.login({token})
                    .then(() => this.userService.login(token, traderId, expireAfter))
                    .then(() => {
                        const user = this.userService.get();

                        if (user.loggedIn && user.id) {
                            // TODO init websocket
                            this.userService.updatePortfolio();
                        }

                        return Promise.all([
                            this.configurationService.init(),
                            this.portfolioService.init()
                        ]).then(() => this.favoriteService.init())
                    })
            }

            logout() {
                console.log('social logout')
                this.portfolioService.clear();
                this.favoriteService.clear();
                this.configurationService.clear();
                this.userService.logout();
            }

            restart() {
                return Promise.resolve()
                    .then(() => this.logout())
                    .then(() => this.getToken())
            }

            checkTradingAccount() {
                const user = this.newforexUserService.get();

                const newforexTradingAccount = user.activeTradingAccount;
                const socialTradingAccount = this.userService.activeTradingAccount;

                // nothing to do
                if (!socialTradingAccount && !newforexTradingAccount) {
                    return
                }

                if (!socialTradingAccount && newforexTradingAccount) {
                    return this.restart()
                }

                if (socialTradingAccount.id !== newforexTradingAccount.id) {
                    return this.restart()
                }
            }

            initTradingAccountListener() {
                const getAccount = () => {
                    const user = this.newforexUserService.get();
                    return user.activeTradingAccount;
                }

                /**
                 * @param newAccount {TradingAccount}
                 * @param prevAccount {TradingAccount}
                 */
                const handleChange = (newAccount, prevAccount) => {
                    console.log('[initTradingAccountListener] newAccount:', newAccount, 'prevAccount:', prevAccount);

                    // if no accounts
                    if (!newAccount && !prevAccount) {
                        return;
                    }

                    // logout
                    if (!newAccount) {
                        this.logout();
                        this.listener && this.listener();
                        this.initialized = false;
                    }
                }

                return this.$rootScope.$watch(
                    () => getAccount(),
                    /**
                     * @param newAccount {TradingAccount}
                     * @param prevAccount {TradingAccount}
                     */
                    (newAccount, prevAccount) => handleChange(newAccount, prevAccount)
                )
            }

        }


        return new SocialInitService();
    }]);
